import { createRouter, createWebHistory } from "vue-router";
import {isAuthenticated, validateCustomer} from "@/helpers/back";

import EmptyLayout from "@/layouts/EmptyLayout.vue";
import Layout from "@/layouts/Layout.vue";
import {useStore} from "@/store";
import {validateNumberParam} from "@/helpers/h2";


const routes = [
  {
    path: "/:pathMatch(.*)*",
    meta: { title: "404" },
    component: EmptyLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/pages/404"),
      },
    ],
  },

  {
    path: '/boards/profile',
    redirect: '/login'
  },

  {
    path: "/login",
    meta: { title: "Авторизация" },
    component: EmptyLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/user/LoginView.vue"),
        // beforeEnter: (to, from, next) => {
        //   const store = useStore();
        //   const customer = store.getP('customer');
        //   const author = store.getP('author');
        //   const backuri = store.getP('backuri');
        //
        //   if (customer) {
        //     next({path: backuri || '/profile/customer'});
        //   } else if (author) {
        //     next({path: backuri || '/profile/author'});
        //   } else {
        //     next();
        //   }
        // }
      }
    ],
  },
  {
    path: "/register",
    meta: { title: "Регистрация" },
    component: EmptyLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/user/RegisterView.vue"),
      },
    ],
  },
  {
    path: "/",
    meta: { title: "Vidu - Видеоплеер для монетизации контент" },
    component: Layout,
    children: [
      {
        path: "",
        name: 'Home',
        component: () => import("@/views/HomeView.vue"),
      },
    ],
  },


  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "payment",
        meta: {title: "Оплата картой"},
        component: () => import("@/views/user/Pay2View.vue"),
      },
      {
        path: "license",
        meta: { title: "Лицензионное соглашение" },
        component: () => import("@/views/pages/License.vue"),
      },
      {
        path: "confidential",
        meta: { title: "Политика конфиденциальности" },
        component: () => import("@/views/pages/Confidential.vue"),
      },
      {
        path: "agreement",
        meta: { title: "Соглашение об использовании видеоплеера" },
        component: () => import("@/views/pages/Agreement.vue"),
      },
      {
        path: "tarif",
        meta: { title: "Тарифы" },
        component: () => import("@/views/pages/Tarif.vue"),
      },
      {
        path: "unsubscribe",
        meta: { title: "Управление подписками", requiresAuth: true },
        component: () => import("@/views/pages/Unsubscribe.vue"),
      },
    ],
  },

  {
    path: "/profile/",
    component: Layout,
    children: [
      {
        path: "author",
        name: 'AuthorProfile',
        meta: { title: "Профиль Автора", requiresAuth: true },
        component: () => import("@/views/user/AuthorProfile.vue"),
      },
      {
        path: "author/constructor",
        name: 'AuthorConstructor',
        meta: { title: "Конструктор Креативов", requiresAuth: true },
        component: () => import("@/views/user/AuthorCreativeConstructor.vue"),
      },
      {
        path: "author/creative/:id",
        name: 'AuthorCreative',
        props: validateNumberParam("id"),
        meta: { title: "Конструктор Креативов", requiresAuth: true },
        component: () => import("@/views/user/AuthorCreativeConstructor.vue"),
      },
      {
        path: "author/stats",
        name: 'AuthorStats',
        meta: { title: "Статистика", requiresAuth: true },
        component: () => import("@/views/user/AuthorStats.vue"),
      },
      {
        path: "author",
        name: 'AuthorProfile',
        meta: { title: "Профиль Автора", requiresAuth: true },
        component: () => import("@/views/user/AuthorProfile.vue"),
      },
      {
        path: "customer",
        meta: { title: "Профиль Зрителя" },
        name: 'CustomerProfile',
        component: () => import("@/views/user/CustomerProfile.vue"),
        beforeEnter: (to, from, next) => {
          const store = useStore();
          const customer = store.getP('customer')
          if(!customer) next("/login")
          next()
        }
      },
    ],
  },

  {
    path: "/pages/",
    redirect: "/pages/404",
    component: EmptyLayout,
    children: [
      {
        path: "404",
        meta: { title: "Страница не найдена - 404" },
        component: () => import("@/views/pages/404"),
      },
      {
        path: "403",
        meta: { title: "Доступ запрещен - 403" },
        component: () => import("@/views/pages/403"),
      },
    ],
  },

  {
    path: "/pays/:page",
    component: () => import("@/views/landings/Wrapper.vue"),
  }

];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta?.requiresAuth) {
    const isAuth = isAuthenticated();
    if (!isAuth) {
      next("/login");
      return;
    }
  }
  next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  document.title = routeTo.meta.title;
  next();
});

const hit = (path_, retry = 0) => {
  const metrikaId = process.env?.VUE_APP_METRIKA ?? 103285269
  if (window?.ym && typeof window.ym === 'function') {
    window.ym(metrikaId, 'hit', path_);
  } else if (retry < 10) {
    setTimeout(() => hit(path_, retry + 1), 500);
  }
}

router.afterEach((to) => {
  hit(to.fullPath);
});

export default router;
